module.exports = __webpack_public_path__ + "img/fart-cloud-2.694b721a.png";